export default __webpack_public_path__ + "static/media/daes-group-logo.2d617253.png";